
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import { getNewslist } from '@/api/youzheng'
import newsList from './components/NewsList.vue'
import config from '@/config/index'
import footnav from '@/views/components/footnav'
export default {
name: 'newscenter',
data () {
return {
bannerlist: []
}
},
created () {
getNewslist({

CATEGORYCODES: 'cat02_01,cat03_01,cat04_01,cat08_01,cat09_01',
pageSize: 5,
pageCurrent: 1,
CONTENTTYPEID: 4,
owner_type: config.owner_type,
searchValue: ''
})
.then(res => {
this.bannerlist = res.obj
})
.catch(res => {
console.log(res, 'getnews false')
})
},
mounted () { },
components: {
Swiper,
SwiperItem,
newsList,
footnav
}
}
